import dayjs from 'dayjs';
import { Lead } from '../../../entities/lead';
import { formatPhoneValue } from '../../../shared/lib/phone';

export const CHANNEL_OPTIONS = [
  { value: 'Manual', label: 'Manual' },
  { value: 'API', label: 'API' },
  { value: 'Skorozvon', label: 'Skorozvon' },
];

export interface LeadFormValues {
  boardId: string;
  userId: string;
  userName: string;
  partnerId: string;
  partnerName: string;
  channel: string;
  title: string;
  taskNumber: string;
  age: string;
  phone: string;
  city: string;
  destination: string;
  sending: string;
  arrival: string;
  note: string;
  source: string;
  actual: boolean;
  orderReceived: boolean;
  tags: string[];
}

export const buildCreateLeadFormValues = ({
  boardId,
  userId,
  userName,
}: {
  boardId: string;
  userId: string;
  userName: string;
}): LeadFormValues => ({
  boardId,
  userId,
  userName,
  partnerId: '',
  partnerName: '',
  channel: 'Manual',
  title: '',
  taskNumber: '',
  age: '',
  phone: formatPhoneValue(''),
  city: '',
  destination: '',
  sending: '',
  arrival: '',
  note: '',
  source: '',
  actual: true,
  orderReceived: false,
  tags: [],
});

export const buildLeadFormValues = (lead: Lead | null): LeadFormValues => ({
  boardId: lead?.boardId ?? '',
  userId: lead?.userId ?? '',
  userName: lead?.expand?.userId?.name ?? '',
  partnerId: lead?.partnerId ?? '',
  partnerName: lead?.expand?.partnerId?.name ?? '',
  channel: lead?.channel ?? 'Manual',
  title: lead?.title ?? '',
  taskNumber: lead?.num != null ? String(lead.num) : '',
  age: lead?.age != null ? String(lead.age) : '',
  phone: formatPhoneValue(lead?.phone),
  city: lead?.city ?? '',
  destination: lead?.destination ?? '',
  sending: lead?.sending ?? '',
  arrival: lead?.arrival ?? '',
  note: lead?.note ?? '',
  source: lead?.source ?? '',
  actual: Boolean(lead?.actual),
  orderReceived: Boolean(lead?.orderReceived),
  tags: lead?.tags ?? [],
});

export const buildLeadPayload = (values: LeadFormValues): Partial<Lead> => ({
  boardId: values.boardId || undefined,
  order: 0,
  userId: values.userId || undefined,
  partnerId: values.partnerId || undefined,
  channel: values.channel || undefined,
  title: values.title.trim(),
  num: values.taskNumber === '' ? null : Number(values.taskNumber),
  age: values.age === '' ? undefined : Number(values.age),
  phone: values.phone.trim() || undefined,
  city: values.city.trim() || undefined,
  destination: values.destination.trim() || undefined,
  // ponytail: шлём '' (не undefined) — иначе PocketBase не очистит поле при update
  sending: values.sending,
  arrival: values.arrival,
  note: values.note.trim() || undefined,
  source: values.source.trim() || undefined,
  actual: values.actual,
  orderReceived: values.orderReceived,
  tags: values.tags,
});

export const validateOptionalPhone = (value: string) => {
  const digits = value.replace(/\D/g, '');
  return !digits || digits.length === 11 || 'Введите телефон полностью';
};

export const validateLeadArrival = (arrival: string, sending: string) => {
  return !arrival || !sending || !dayjs(arrival).isBefore(dayjs(sending)) || 'Дата приезда не может быть раньше отправки';
};
